import { render, staticRenderFns } from "./DigitalOrderEmail.vue?vue&type=template&id=7c78a2e5&scoped=true"
import script from "./DigitalOrderEmail.vue?vue&type=script&lang=js"
export * from "./DigitalOrderEmail.vue?vue&type=script&lang=js"
import style0 from "./DigitalOrderEmail.vue?vue&type=style&index=0&id=7c78a2e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c78a2e5",
  null
  
)

export default component.exports